import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth, API } from '../App';
import { DashboardLayout } from '../components/DashboardLayout';
import { motion } from 'framer-motion';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';
import { Sparkles, ArrowRight, Heart } from 'lucide-react';

const JourneyStart = () => {
  const { user, token } = useAuth();
  const navigate = useNavigate();
  const [expectations, setExpectations] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (expectations.trim().length < 10) {
      toast.error('Prends quelques secondes pour partager tes attentes...');
      return;
    }

    setIsSubmitting(true);
    try {
      const headers = { Authorization: `Bearer ${token}` };
      await axios.post(`${API}/journey/save-expectations`, 
        { expectations: expectations.trim() },
        { headers }
      );
      
      toast.success('Merci ! Ton parcours commence maintenant ✨');
      
      // Navigate to dashboard after short delay
      setTimeout(() => {
        navigate('/dashboard');
      }, 1000);
      
    } catch (error) {
      console.error('Error saving expectations:', error);
      toast.error('Une erreur est survenue. Réessaie.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <DashboardLayout>
      <div className="max-w-2xl mx-auto py-12 px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <div className="inline-flex items-center gap-2 mb-6">
            <Heart className="text-[#D4AF37]" size={24} />
            <span className="text-[#D4AF37] text-xs font-accent tracking-[0.25em]">BIENVENUE</span>
          </div>
          
          <h1 className="font-serif text-4xl md:text-5xl text-white mb-4">
            Avant de commencer...
          </h1>
          
          <p className="text-[#A1A1AA] font-light text-lg">
            Prends un instant pour toi
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="card-gold p-8"
        >
          <div className="mb-8">
            <label className="block text-white font-serif text-xl mb-4">
              Qu'est-ce que tu attends de Vision Lab ?
            </label>
            
            <textarea
              value={expectations}
              onChange={(e) => setExpectations(e.target.value)}
              placeholder="Ce que tu veux améliorer... Ce que tu ressens aujourd'hui... Ce que tu aimerais changer..."
              className="w-full h-40 bg-[#0A0A0A] border border-[#27272A] text-white p-4 font-light placeholder:text-[#52525B] focus:border-[#D4AF37]/50 focus:outline-none transition-colors resize-none"
            />
            
            <p className="text-[#52525B] text-xs mt-2 text-right">
              {expectations.length} caractères
            </p>
          </div>

          <div className="flex flex-col items-center gap-4">
            <Button
              onClick={handleSubmit}
              disabled={isSubmitting || expectations.trim().length < 10}
              className="btn-gold w-full py-5 text-base"
              data-testid="start-journey-btn"
            >
              <Sparkles size={18} className="mr-2" />
              {isSubmitting ? 'Un instant...' : 'Commencer mon parcours'}
              <ArrowRight size={18} className="ml-2" />
            </Button>
            
            <p className="text-[#52525B] text-xs text-center">
              Tes réponses sont privées et nous aident à personnaliser ton expérience
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
          className="mt-8 text-center"
        >
          <p className="text-[#52525B] text-sm font-light italic">
            "Le premier pas vers ta transformation commence par la clarté de tes intentions"
          </p>
        </motion.div>
      </div>
    </DashboardLayout>
  );
};

export default JourneyStart;
